export type Tone = 'natural' | 'academic' | 'simple' | 'confident';
export type Strength = 'light' | 'balanced' | 'deep';

export type HumanizerPrefs = {
  tone: Tone;
  strength: Strength;
  guard: boolean;
};

const KEY = 'phrasio-humanizer-settings';

const defaults: HumanizerPrefs = {
  tone: 'natural',
  strength: 'balanced',
  guard: true,
};

export function loadPrefs(): HumanizerPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw) as Partial<HumanizerPrefs>;
    return {
      tone: parsed.tone === 'academic' || parsed.tone === 'simple' || parsed.tone === 'confident' ? parsed.tone : 'natural',
      strength: parsed.strength === 'light' || parsed.strength === 'deep' ? parsed.strength : 'balanced',
      guard: parsed.guard !== false,
    };
  } catch {
    return defaults;
  }
}

export function savePrefs(prefs: HumanizerPrefs) {
  localStorage.setItem(KEY, JSON.stringify(prefs));
}
